<template>
    <v-app>
        <Header :cambiopassword='this.cambiopass' />
        <Sidebar />

        <v-main class="content mx-0 mx-md-2">
            <router-view></router-view>
            <Helper />

        </v-main>
        <Footer />
    </v-app>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import MainService from "@/services/main/main.service.js";
import Security from "@/utils/security.vue.js";
import ManagerLocalStorage from '@/utils/managerLocalStorage.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Header from '@/views/shared/header/Header.vue';
import Footer from '@/views/shared/footer/Footer.vue';
import Sidebar from '@/views/shared/sidebar/Sidebar.vue';
import Helper from '@/views/shared/helper/Helper.vue';
import router from '@/router'

export default {
    components: {
        Header,
        Sidebar,
        Helper,
        Footer
    },
    data() {
        return {
            ResultadoBusqueda: false,
            cambiopass: false,
        }
    },

    computed: {
        ...mapState(['user', 'permission', 'informationPage', 'domain', 'tipo']),
        ...mapGetters(['getUser'])
    },
    methods: {
        ...mapMutations(['fillDataUser']),
        async ValidarContraseña() {
            let password = await MetodosGenerales.obtenerSessionReporte('password');
            if (password.tipo == 'O' || password.tipo == 'N') {
                router.push({ name: "perfilusuario", }).catch(err => err)
            }
        }
    },
    created() {
        MainService.serviceWorkerStart();
        this.fillDataUser(ManagerLocalStorage.getSingleValueInLocalStorage(this.informationPage.nameLocalStoragePGV2));
    },
    mounted() {

        MetodosGenerales.registrarPaginaVisitada(this);
        Security.verifyGlobalPermission(this.getUser, this.permission.global, "noautorizado", this.$router, ManagerLocalStorage.getSingleValueInLocalStorage(this.informationPage.nameLocalStoragePGV2));
    },
    updated() {
        this.ValidarContraseña();
    },
    beforeUpdate() {
        MetodosGenerales.registrarPaginaVisitada(this);
        Security.verifyGlobalPermission(this.getUser, this.permission.global, "noautorizado", this.$router, ManagerLocalStorage.getSingleValueInLocalStorage(this.informationPage.nameLocalStoragePGV2));
    },
}
</script>

